import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["container"]

    connect() {
        this.boundUpdate = () => this.updateCount()
        document.addEventListener('values-changed', this.boundUpdate)
        document.addEventListener('filters-changed', this.boundUpdate)
        // Sync on initial render (e.g. saved search restoration)
        this.updateCount()
    }

    disconnect() {
        document.removeEventListener('values-changed', this.boundUpdate)
        document.removeEventListener('filters-changed', this.boundUpdate)
    }

    updateCount() {
        const lists = this.containerTarget.querySelectorAll('[data-multi-value-input-target="list"]');

        let valuesCount = 0
        Array.from(lists).forEach(list => {
            valuesCount += list.children.length;
        })

        const textElement = this.containerTarget.querySelector('#totalValuesCount')
        if (!textElement) return
        textElement.innerHTML = `${valuesCount}`
        const pill = textElement.closest('.lf-filter-count') || textElement
        pill.dataset.count = valuesCount
        if (valuesCount > 0) {
            pill.removeAttribute('hidden')
        } else {
            pill.setAttribute('hidden', '')
        }
        // A filter that holds something reads differently in the list, the way
        // the mockup has it - the label goes semibold, not just the badge.
        this.element.classList.toggle('lf-filter--active', valuesCount > 0)
    }
}
